export const CELL_HEIGHT = 70

export const COLUMN_SIZE = {
  LG: 300,
  MD: 150,
  SM: 100,
  XS: 70,
} as const
